// import platform from '@/views/platform/index.vue';
const platformRoute = [
    // {
    //     path: '/platform',
    //     name: 'platform',
    //     component: platform
    // },
]

export default platformRoute